export const objToQueryString = (obj) => {
	return Object.keys(obj)
		.map((key) => key + "=" + obj[key])
		.join("&");
};

export const queryStringToJSON = (value) => {
	const pairs = value.split("?")[1].split("&");
	const result = {};
	pairs.map((pair) => {
		pair = pair.split("=");
		return (result[pair[0]] = decodeURIComponent(pair[1] || ""));
	});
	return JSON.parse(JSON.stringify(result));
};

export const hexToRgb = (hex) => {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}` : `0,0,0`;
};

export const splitArr = (arr, n) => {
	const res = [];
	const div = Math.round(arr.length / n);
	while (arr.length) {
		res.push(arr.splice(0, div));
	}
	return res;
};

export const getYouTubeVideoId = ({ url }) => {
	let video_id = url.split("v=")[1];
	const ampersandPosition = video_id && video_id.indexOf("&");
	if (ampersandPosition !== -1) {
		video_id = video_id && video_id.substring(0, ampersandPosition);
	}
	return video_id;
};

export const secondsToTime = (duration) => {
	let seconds = parseInt(duration % 60);
	let minutes = parseInt((duration / 60) % 60);
	let hours = parseInt((duration / (60 * 60)) % 24);

	hours = hours < 10 ? "0" + hours : hours;
	minutes = minutes < 10 ? "0" + minutes : minutes;
	seconds = seconds < 10 ? "0" + seconds : seconds;
	return hours + ":" + minutes + ":" + seconds;
};
